<template>
  <div class="upload-files" v-loading="loading" :element-loading-text="$t('努力加载中')" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <template v-for="(item,index) in items">
      <div class="upload-item-box" :key="index">
        <div class="item-left-box">
          <div class="flag-box"><i :class="{'el-icon-circle-check':((item.srcList=== undefined ||item.srcList.length==0)&&(item.pdfsrcList=== undefined ||item.pdfsrcList.length==0)),'el-icon-success':(item.srcList!== undefined && item.srcList.length>0)||(item.pdfsrcList!== undefined && item.pdfsrcList.length>0)}"></i></div>
          <div class="title-box">
            {{item.name}}
          </div>
          <div v-if="!disabled">
            <UploadFiles :imgdata="item" :fileDir="'customer'"></UploadFiles>
          </div>
        </div>
        <div class="item-right-box">
          <div class="img-item-box" v-for="(img,index2) in item.srcList" :key="'img'+index2">
            <span v-if="!disabled" class="del-btn" @click="delimg(index,index2)">
              <i class="el-icon-circle-close"></i>
            </span>
            <el-image class="img-item" :src="img" :preview-src-list="item.srcList">
            </el-image>
          </div>
          <div class="img-item-box" v-for="(img,index2) in item.pdfsrcList" :key="'pdf'+index2">
            <span v-if="!disabled" class="del-btn" @click="delpdf(index,index2)">
              <i class="el-icon-circle-close"></i>
            </span>
            <el-image class="img-item" :src="img" @click="showpdf(item.pdfblobList[index2])"></el-image>
            <div class="pdf-notice">PDF附件</div>
          </div>
        </div>
      </div>
    </template>
    <!-- <div class="notice">支持GIF、JPEG、JPG、PNG、PDF文件上傳</div> -->
  </div>
</template>

<script>
import UploadFiles from "@/components/UploadFiles.vue";
export default {
  components: {
    UploadFiles
  },
  props: {
    type: {
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    files: {
      type: Array,
      default: () => [],
    },
    showdata: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      loading: false,
      items: [
        // { id: 1, name: '董事、股東、獲授權代表的身分證或護照', srcList: [], blobList: [], pdfsrcList: [], pdfblobList: [] },
      ]
    }
  },
  methods: {
    init () {
      this.loading = true;
      let type = this.type;
      let showdata = this.showdata;
      let files = this.files;
      let urls = [];
      showdata.some(sitem => {
        urls.push(sitem.fileurl);
      })

      // 獲取新增的附件
      files = files.map(fitem => {
        fitem.srcList = fitem.srcList.filter(srcitem => {
          if (urls.indexOf(srcitem) != -1) {
            return false;
          } else {
            return true;
          }
        })

        fitem.pdfsrcList = fitem.pdfsrcList.filter(pdfsrcitem => {
          if (urls.indexOf(pdfsrcitem) != -1) {
            return false;
          } else {
            return true;
          }
        })
        return fitem;
      })


      let pdficon = require('../assets/pdf.png');
      this.post('/api/customer/files_type', { type: type }).then(response => {
        this.items = response.map(item => {
          item.srcList = [];
          item.blobList = [];
          item.pdfsrcList = [];
          item.pdfblobList = [];
          showdata.some(showitem => {
            if (showitem.files_type_id == item.id) {
              if (showitem.files_type == 0) {
                item.srcList.push(showitem.url);
                item.blobList.push(showitem.fileurl);
              } else {
                item.pdfsrcList.push(pdficon);
                item.pdfblobList.push(showitem.fileurl);
              }
            }
          })

          // 防止頁面重新加載，把新增的圖片或附件刪除
          files.some(fileitem => {
            if (fileitem.id == item.id) {
              if (fileitem.srcList.length > 0) {
                fileitem.srcList.some(ffitem => {
                  item.srcList.push(this.$apiBaseUrl+ffitem);
                  item.blobList.push(ffitem);
                })
              }

              if (fileitem.pdfsrcList.length > 0) {
                fileitem.pdfsrcList.some(ffitem => {
                  item.pdfsrcList.push(this.$apiBaseUrl+ffitem);
                  item.pdfblobList.push(ffitem);
                })
              }
            }
          })

          return item;
        });
        this.loading = false;
      }).catch(error => {
        console.log(error);
      })
    },
    showpdf (blob) {
      window.open(this.apiurl + blob);
    },
    delimg (index, imgidx) {
      this.items.map((item, idx) => {
        if (idx == index) {
          // 刪除bloburl
          let srcList = item.srcList.filter((subitem, idx) => {
            if (idx == imgidx) {
              return false;
            } else {
              return true;
            }
          })
          // 刪除blob
          let blobList = item.blobList.filter((subitem, idx) => {
            if (idx == imgidx) {
              return false;
            } else {
              return true;
            }
          })
          item.srcList = srcList;
          item.blobList = blobList;
        }
        return item;
      })
    },
    delpdf (index, imgidx) {
      this.items.map((item, idx) => {
        if (idx == index) {
          // 刪除bloburl
          let pdfsrcList = item.pdfsrcList.filter((subitem, idx) => {
            if (idx == imgidx) {
              return false;
            } else {
              return true;
            }
          })
          // 刪除blob
          let pdfblobList = item.pdfblobList.filter((subitem, idx) => {
            if (idx == imgidx) {
              return false;
            } else {
              return true;
            }
          })
          item.pdfsrcList = pdfsrcList;
          item.pdfblobList = pdfblobList;
        }
        return item;
      })
    },
  },
  created () {
    this.init();
  },
  watch: {
    type: {
      handler: function (newVal, oldVal) {
        this.init();
      },
      deep: true
    },
    items: {
      handler: function (newVal, oldVal) {
        let items = newVal.map(item => {
          let temp = {};
          temp.id = item.id;
          temp.srcList = item.blobList;
          temp.pdfsrcList = item.pdfblobList;
          return temp;
        })
        this.$emit('update:files', items);
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.notice{
  color:#999;
}
.upload-files {
  min-height: 100px;
}
.upload-item-box {
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 1px dotted #cccccc;
}
.item-left-box i {
  font-size: 25px !important;
}
.item-left-box {
  padding: 10px 0;
  flex: 1;
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.item-right-box {
  padding: 10px 0;
  flex: 1;
  align-items: center;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.flag-box {
  margin-right: 15px;
}
.title-box {
  flex: 1;
  text-align: left;
}

.img-item-box {
  display: flex;
  align-items: center;
  position: relative;
  border: 1px solid #eaeaea;
  margin: 5px;
}
.img-item-box .del-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 10;
}

.img-item-box .pdf-notice {
  position: absolute;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  width: 100%;
  bottom: 0;
  left: 0;
  font-size: 12px !important;
  z-index: 10;
}

.img-item-box .del-btn i {
  font-size: 18px !important;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}

.img-item-box .del-btn i:hover {
  cursor: pointer;
  background-color: rgba(255, 0, 0, 0.9);
}

.img-item {
  cursor: pointer;
  width: 60px;
  height: 60px;
}

.el-icon-circle-check {
  color: rgba(0, 0, 0, 0.1);
}
.el-icon-success {
  color: green;
}
.el-image-viewer__close {
  width: 60px;
  height: 60px;
}
.el-image-viewer__btn {
  opacity: 0.9;
}
/deep/ .el-image-viewer__btn i {
  font-size: 30px !important;
  color: #ffffff;
}

@media (max-width: 1024px) {
  .el-image-viewer__close {
    width: 40px;
    height: 40px;
  }
  .el-image-viewer__btn {
    opacity: 0.9;
  }
  /deep/ .el-image-viewer__btn i {
    color: #ffffff;
    font-size: 25px !important;
  }
  .img-item {
    width: 100px;
    height: 100px;
  }
  .item-left-box {
    flex: none;
    padding: 10px 0;
    align-items: center;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    width: 100%;
  }

  .item-right-box {
    flex: none;
    padding: 10px 0;
    align-items: center;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
  }
}
</style>